// DM12 — "you are here" readout (dev view only, DECIDED John 2026-06-23). The
// conductor's coherence test includes "where am I?": at any moment the surface
// should name the podium state — which camera, which view, powered or dark. A
// small, unobtrusive top-left line (under the logo/audio cluster) answers it.
// The demo/performance view stays clean (this is never created there).
//
// Write-on-change (PF6 discipline): the render loop calls update() every frame
// but the DOM only mutates when the string actually changes, so it costs
// nothing when the podium state is steady.

export interface YouAreHereDeps {
  /** Active camera mode name (e.g. 'freeform', 'interior-orbit', 'external-view'). */
  cameraName: () => string;
  /** Current view ('exterior' | 'interior'). */
  view: () => string;
  /** Is the generator powered (the scene awake)? */
  powered: () => boolean;
}

export interface YouAreHere {
  update(): void;
  dispose(): void;
}

export function createYouAreHere(deps: YouAreHereDeps): YouAreHere {
  const el = document.createElement('div');
  el.id = 'lec-you-are-here';
  Object.assign(el.style, {
    position: 'fixed',
    top: '72px', // clears the logo + audio-controls cluster (which ends at y≈64)
    left: '16px',
    zIndex: '900',
    font: "10px/1.3 ui-monospace, 'SF Mono', Menlo, monospace",
    color: 'rgba(230,235,239,0.55)',
    letterSpacing: '0.3px',
    pointerEvents: 'none',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    textShadow: '0 1px 2px rgba(0,0,0,0.6)',
  });
  document.body.appendChild(el);

  let last = '';
  const update = (): void => {
    const txt = `${deps.cameraName()} · ${deps.view()} · ${deps.powered() ? '⚡ powered' : '○ dark'}`;
    if (txt !== last) { el.textContent = txt; last = txt; } // write-on-change
  };
  update();

  return { update, dispose: () => el.remove() };
}
